import React from 'react'
//@ts-ignore
import s from './SectionParams.module.scss'
export type SectionParamsT = {
    children?: any;
    key?: string;
    label?: string;
}


export const SectionParams: React.FC<SectionParamsT> = ({ ...props }) => {
    let { children, label } = props
    return (
        <div className={s.wrap}>
            {label && (
                <div className={s.header}>
                    <div className={s.title}>{label}</div>
                </div>
            )}

            <div className={s.main}>{children}</div>

        </div>
    )
}
